/* eslint-disable */
// @ts-nocheck
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type BffAdditionalInfo = {
  __typename?: 'BffAdditionalInfo';
  available_categories?: Maybe<Scalars['String']['output']>;
  available_services?: Maybe<Scalars['String']['output']>;
  can_book?: Maybe<Scalars['Boolean']['output']>;
  cancellation_fee_duration?: Maybe<Scalars['Int']['output']>;
  categories_available?: Maybe<Scalars['Boolean']['output']>;
  center_amenities?: Maybe<Scalars['String']['output']>;
  collect_feedback?: Maybe<Scalars['String']['output']>;
  cst?: Maybe<Scalars['String']['output']>;
  feedback_label?: Maybe<Scalars['String']['output']>;
  feedback_link?: Maybe<Scalars['String']['output']>;
  is_add_ons_available?: Maybe<Scalars['Boolean']['output']>;
  is_auto_pay_enabled_at_center?: Maybe<Scalars['Boolean']['output']>;
  is_center_amenities_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_global_tokenization_supported?: Maybe<Scalars['Boolean']['output']>;
  service_tax_no?: Maybe<Scalars['String']['output']>;
  services_available?: Maybe<Scalars['Boolean']['output']>;
  tin?: Maybe<Scalars['String']['output']>;
  unavailable_categories?: Maybe<Scalars['String']['output']>;
  unavailable_services?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type BffAddress = {
  __typename?: 'BffAddress';
  address_1?: Maybe<Scalars['String']['output']>;
  address_2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BffBrand = {
  __typename?: 'BffBrand';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<BffBrandType>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum BffBrandType {
  AspenDental = 'ASPEN_DENTAL',
  AzPet = 'AZ_PET',
  Chapter = 'CHAPTER',
  ClearChoice = 'CLEAR_CHOICE',
  Lovet = 'LOVET',
  WellNow = 'WELL_NOW'
}

export type BffCacheStats = {
  __typename?: 'BffCacheStats';
  expires?: Maybe<Scalars['String']['output']>;
  hits?: Maybe<Scalars['Float']['output']>;
  keys?: Maybe<Scalars['Float']['output']>;
  keysSize?: Maybe<Scalars['Float']['output']>;
  misses?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  now?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  valuesSize?: Maybe<Scalars['Float']['output']>;
};

export type BffCenter = {
  __typename?: 'BffCenter';
  additional_info?: Maybe<BffAdditionalInfo>;
  address_info?: Maybe<BffAddress>;
  code?: Maybe<Scalars['String']['output']>;
  contact_info?: Maybe<BffContactInfo>;
  country?: Maybe<BffCountry>;
  culture_code_at_center?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<BffCurrency>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  enable_parallel_services_at_center?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  is_fbe_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_hc_call_center?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<BffLocation>;
  name?: Maybe<Scalars['String']['output']>;
  online_booking_start_date?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  state?: Maybe<BffState>;
  working_hours?: Maybe<Array<Maybe<BffWorkinghours>>>;
};

export type BffCenters = {
  __typename?: 'BffCenters';
  centers?: Maybe<Array<Maybe<BffCenter>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BffCity = {
  __typename?: 'BffCity';
  city?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffContactInfo = {
  __typename?: 'BffContactInfo';
  email?: Maybe<Scalars['String']['output']>;
  phone_1?: Maybe<BffPhoneNumber>;
  phone_2?: Maybe<BffPhoneNumber>;
};

export type BffCountry = {
  __typename?: 'BffCountry';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone_code?: Maybe<Scalars['Int']['output']>;
};

export type BffCurrency = {
  __typename?: 'BffCurrency';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffDamAsset = {
  __typename?: 'BffDamAsset';
  height?: Maybe<Scalars['Int']['output']>;
  mimetype?: Maybe<Scalars['String']['output']>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/**
 * An office facility
 * Brick and Mortar part of **business** [API](http://example.com)!
 */
export type BffFacility = {
  __typename?: 'BffFacility';
  address?: Maybe<BffFacilityAddress>;
  anytimeAppointingDenture?: Maybe<Scalars['Boolean']['output']>;
  anytimeAppointingMotto?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Array<Maybe<NamedAttribute>>>;
  birdeyeBusinessId?: Maybe<Scalars['String']['output']>;
  /** Brand where the data is from */
  brand?: Maybe<Scalars['String']['output']>;
  clockwiseId?: Maybe<Scalars['String']['output']>;
  /** Facility Code or Id */
  code: Scalars['String']['output'];
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dma?: Maybe<Scalars['String']['output']>;
  dnis?: Maybe<Scalars['String']['output']>;
  doctors?: Maybe<Array<Maybe<BffProvider>>>;
  email?: Maybe<Scalars['String']['output']>;
  emergencyPhoneNumber?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  firstThreeOctets?: Maybe<Scalars['String']['output']>;
  geomodifier?: Maybe<Scalars['String']['output']>;
  implants?: Maybe<Scalars['String']['output']>;
  insurance?: Maybe<Array<Maybe<BffInsurance>>>;
  insuranceNetwork?: Maybe<Array<Maybe<BffInsurance>>>;
  legalBillingName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<BffFacilityLocation>;
  minimumPatientAge?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsBasedQuestions?: Maybe<Scalars['Boolean']['output']>;
  onHVP?: Maybe<Scalars['Boolean']['output']>;
  onMotto?: Maybe<Scalars['Boolean']['output']>;
  onP3?: Maybe<Scalars['Boolean']['output']>;
  openDate?: Maybe<Scalars['String']['output']>;
  originalBrand?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pilot1?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  revspringAccountId?: Maybe<Scalars['String']['output']>;
  revspringLocationValue?: Maybe<Scalars['String']['output']>;
  scheduleAppointmentURL?: Maybe<Scalars['String']['output']>;
  schedulingSystem?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
  siteGroup?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<Maybe<BffWorkingHours>>>;
};

export type BffFacilityAddress = {
  __typename?: 'BffFacilityAddress';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BffFacilityCollection = {
  __typename?: 'BffFacilityCollection';
  items?: Maybe<Array<Maybe<BffFacility>>>;
  skip?: Maybe<Scalars['Int']['output']>;
  take?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type BffFacilityLocation = {
  __typename?: 'BffFacilityLocation';
  directions?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  landmarks?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  neighboringAreas?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  timezoneIANA?: Maybe<Scalars['String']['output']>;
};

export type BffFutureDays = {
  __typename?: 'BffFutureDays';
  Day?: Maybe<Scalars['String']['output']>;
  HolidayType?: Maybe<Scalars['String']['output']>;
  IsAvailable?: Maybe<Scalars['Boolean']['output']>;
};

export type BffInsurance = {
  __typename?: 'BffInsurance';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BffLocation = {
  __typename?: 'BffLocation';
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  time_zone?: Maybe<BffTimezone>;
};

export type BffPhoneNumber = {
  __typename?: 'BffPhoneNumber';
  country_id?: Maybe<Scalars['Int']['output']>;
  display_number?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type BffPriceInfo = {
  __typename?: 'BffPriceInfo';
  currency_id?: Maybe<Scalars['Int']['output']>;
  demand_group_id?: Maybe<Scalars['String']['output']>;
  include_tax?: Maybe<Scalars['Boolean']['output']>;
  sale_price?: Maybe<Scalars['Float']['output']>;
  ssg?: Maybe<Scalars['Int']['output']>;
  tax_id?: Maybe<Scalars['String']['output']>;
};

export type BffProduct = {
  __typename?: 'BffProduct';
  brand: Scalars['String']['output'];
  brandfolderImageAssetUrl?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  procedures?: Maybe<Array<Maybe<BffProductProcedure>>>;
  subCategory?: Maybe<Scalars['String']['output']>;
};

export type BffProductProcedure = {
  __typename?: 'BffProductProcedure';
  /** The price for the procedure, it can be average if not sought by facility, or specific to the facility selected. */
  price: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
};

export type BffProvider = {
  __typename?: 'BffProvider';
  active?: Maybe<Scalars['Boolean']['output']>;
  associations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  biography?: Maybe<Scalars['String']['output']>;
  collegeCity?: Maybe<Scalars['String']['output']>;
  collegeName?: Maybe<Scalars['String']['output']>;
  collegeState?: Maybe<Scalars['String']['output']>;
  degreeName?: Maybe<Scalars['String']['output']>;
  employeeStatus?: Maybe<Scalars['String']['output']>;
  ethnicity?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  graduationDate?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<Maybe<BffProviderLicense>>>;
  name?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerType?: Maybe<Scalars['String']['output']>;
  specialties?: Maybe<Scalars['String']['output']>;
  volunteerism?: Maybe<Scalars['String']['output']>;
};

export type BffProviderLicense = {
  __typename?: 'BffProviderLicense';
  state?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type BffRating = {
  __typename?: 'BffRating';
  rating?: Maybe<Scalars['Float']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
};

export type BffReview = {
  __typename?: 'BffReview';
  comments?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewId?: Maybe<Scalars['String']['output']>;
  reviewTimestamp?: Maybe<Scalars['String']['output']>;
  reviewer?: Maybe<BffReviewReviewer>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type BffReviewReviewer = {
  __typename?: 'BffReviewReviewer';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type BffReviews = {
  __typename?: 'BffReviews';
  averageRating?: Maybe<Scalars['Float']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Maybe<BffRating>>>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  reviews?: Maybe<Array<Maybe<BffReview>>>;
};

export type BffService = {
  __typename?: 'BffService';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  add_ons_info?: Maybe<Scalars['String']['output']>;
  additional_info?: Maybe<Scalars['String']['output']>;
  catalog_info?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  dentureCouponCode?: Maybe<Scalars['String']['output']>;
  dentureFee?: Maybe<Scalars['Int']['output']>;
  dentureFlag?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  finishing_services_info?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  generalDentFee?: Maybe<Scalars['Int']['output']>;
  generalDentistryCouponCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image_paths?: Maybe<Scalars['String']['output']>;
  is_couple_service?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parallel_groups?: Maybe<Scalars['String']['output']>;
  parallel_service_groups?: Maybe<Scalars['String']['output']>;
  prerequisites_info?: Maybe<Scalars['String']['output']>;
  price_info?: Maybe<BffPriceInfo>;
  procedureCategory?: Maybe<Scalars['String']['output']>;
  procedureCode?: Maybe<Scalars['String']['output']>;
  procedureDescription?: Maybe<Scalars['String']['output']>;
  promotionalPrice?: Maybe<Scalars['Int']['output']>;
  recovery_time?: Maybe<Scalars['Int']['output']>;
  variants_info?: Maybe<Scalars['String']['output']>;
};

export type BffServices = {
  __typename?: 'BffServices';
  error?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Array<Maybe<BffService>>>;
};

export type BffSession = {
  __typename?: 'BffSession';
  Error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BffSlot = {
  __typename?: 'BffSlot';
  Available?: Maybe<Scalars['Boolean']['output']>;
  Priority?: Maybe<Scalars['Int']['output']>;
  SalePrice?: Maybe<Scalars['String']['output']>;
  Time?: Maybe<Scalars['String']['output']>;
  Warnings?: Maybe<Scalars['String']['output']>;
};

export type BffSlots = {
  __typename?: 'BffSlots';
  Error?: Maybe<Scalars['String']['output']>;
  future_days?: Maybe<Array<Maybe<BffFutureDays>>>;
  next_available_day?: Maybe<Scalars['String']['output']>;
  slots?: Maybe<Array<Maybe<BffSlot>>>;
};

export type BffState = {
  __typename?: 'BffState';
  abbreviation?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
};

export type BffTimeSpan = {
  __typename?: 'BffTimeSpan';
  /** The LocalTime scalar type is a local time string (i.e., with no associated timezone) in 24-hr HH:mm:ss. */
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type BffTimezone = {
  __typename?: 'BffTimezone';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  standard_name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
};

export type BffUsCity = {
  __typename?: 'BffUSCity';
  city?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugXml?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbreviation?: Maybe<Scalars['String']['output']>;
};

export type BffWorkingHours = {
  __typename?: 'BffWorkingHours';
  date?: Maybe<Scalars['String']['output']>;
  open?: Maybe<BffTimeSpan>;
};

export type BffWorkinghours = {
  __typename?: 'BffWorkinghours';
  day_of_week?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['String']['output']>;
  is_closed?: Maybe<Scalars['Boolean']['output']>;
  off_peak_end_time?: Maybe<Scalars['String']['output']>;
  off_peak_start_time?: Maybe<Scalars['String']['output']>;
  offline_end_time?: Maybe<Scalars['String']['output']>;
  offline_start_time?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['String']['output']>;
};

export type NamedAttribute = {
  __typename?: 'NamedAttribute';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  cacheStats?: Maybe<Array<Maybe<BffCacheStats>>>;
  changeCacheTTL?: Maybe<BffCacheStats>;
  createBooking?: Maybe<BffSession>;
  facilitiesByAddress?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByState?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateAndCity?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndStreet?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByStateCityAndZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilitiesByZipcode?: Maybe<Array<Maybe<BffFacility>>>;
  facilityBrand?: Maybe<Array<Maybe<BffBrand>>>;
  facilityById?: Maybe<BffFacility>;
  facilityByLocation?: Maybe<Array<Maybe<BffFacility>>>;
  facilityCities?: Maybe<Array<Maybe<BffUsCity>>>;
  facilityCitiesByState?: Maybe<Array<Maybe<BffCity>>>;
  facilityCollection?: Maybe<BffFacilityCollection>;
  facilityPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  facilityStates?: Maybe<Array<Maybe<BffState>>>;
  getCenters?: Maybe<BffCenters>;
  getServices?: Maybe<BffServices>;
  getSlots?: Maybe<BffSlots>;
  invalidateCache?: Maybe<BffCacheStats>;
  productByName?: Maybe<BffProduct>;
  productByNameAndFacility?: Maybe<BffProduct>;
  providerPicById?: Maybe<Array<Maybe<BffDamAsset>>>;
  providerPicByNpi?: Maybe<Array<Maybe<BffDamAsset>>>;
  reviews?: Maybe<BffReviews>;
  states?: Maybe<Array<Maybe<BffState>>>;
  statesByAbbreviation?: Maybe<BffState>;
  statesByName?: Maybe<BffState>;
};


export type QueryChangeCacheTtlArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ttlInSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreateBookingArgs = {
  brand: BffBrandType;
  centerId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  isDoubleBookingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyCatalogEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId: Scalars['String']['input'];
};


export type QueryFacilitiesByAddressArgs = {
  address: Scalars['String']['input'];
  brand: BffBrandType;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateAndCityArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndStreetArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
};


export type QueryFacilitiesByStateCityAndZipcodeArgs = {
  brand: BffBrandType;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryFacilitiesByZipcodeArgs = {
  brand: BffBrandType;
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryFacilityByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityByLocationArgs = {
  brand: BffBrandType;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  maxItems?: InputMaybe<Scalars['Int']['input']>;
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityCitiesArgs = {
  brand: BffBrandType;
};


export type QueryFacilityCitiesByStateArgs = {
  brand: BffBrandType;
  state: Scalars['String']['input'];
};


export type QueryFacilityCollectionArgs = {
  brand: BffBrandType;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFacilityPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryFacilityStatesArgs = {
  brand: BffBrandType;
};


export type QueryGetCentersArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetServicesArgs = {
  brand: BffBrandType;
  catalogEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  centerId: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetSlotsArgs = {
  bookingId: Scalars['String']['input'];
  brand: BffBrandType;
  checkFutureDayAvailablity?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvalidateCacheArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryProductByNameArgs = {
  brand: BffBrandType;
  name: Scalars['String']['input'];
};


export type QueryProductByNameAndFacilityArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QueryProviderPicByIdArgs = {
  brand: BffBrandType;
  id: Scalars['String']['input'];
};


export type QueryProviderPicByNpiArgs = {
  brand: BffBrandType;
  npi: Scalars['String']['input'];
};


export type QueryReviewsArgs = {
  brand: BffBrandType;
  facilityCode: Scalars['String']['input'];
};


export type QueryStatesByAbbreviationArgs = {
  abbreviation: Scalars['String']['input'];
};


export type QueryStatesByNameArgs = {
  name: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'Token';
  access_token?: Maybe<Scalars['String']['output']>;
};

export type BffNearbyFacilitiesByLocationQueryVariables = Exact<{
  brand: BffBrandType;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
}>;


export type BffNearbyFacilitiesByLocationQuery = { __typename?: 'Query', facilityByLocation?: Array<{ __typename?: 'BffFacility', code: string, name?: string | null, phoneNumber?: string | null, scheduleAppointmentURL?: string | null, schedulingSystem?: string | null, address?: { __typename?: 'BffFacilityAddress', address1?: string | null, address2?: string | null, city?: string | null, stateCode?: string | null, zipCode?: string | null } | null, location?: { __typename?: 'BffFacilityLocation', distance?: number | null, latitude?: number | null, longitude?: number | null, timeZone?: string | null } | null } | null> | null };

export type BffNearbyFacilitiesByZipcodeQueryVariables = Exact<{
  brand: BffBrandType;
  zipCode: Scalars['String']['input'];
  radiusMiles?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BffNearbyFacilitiesByZipcodeQuery = { __typename?: 'Query', facilitiesByZipcode?: Array<{ __typename?: 'BffFacility', code: string, name?: string | null, phoneNumber?: string | null, scheduleAppointmentURL?: string | null, schedulingSystem?: string | null, address?: { __typename?: 'BffFacilityAddress', address1?: string | null, address2?: string | null, city?: string | null, stateCode?: string | null, zipCode?: string | null } | null, location?: { __typename?: 'BffFacilityLocation', distance?: number | null, latitude?: number | null, longitude?: number | null, timeZone?: string | null } | null } | null> | null };


export const BffNearbyFacilitiesByLocationDocument = gql`
    query bffNearbyFacilitiesByLocation($brand: BffBrandType!, $latitude: Float!, $longitude: Float!) {
  facilityByLocation(brand: $brand, latitude: $latitude, longitude: $longitude) {
    code
    name
    phoneNumber
    address {
      address1
      address2
      city
      stateCode
      zipCode
    }
    scheduleAppointmentURL
    schedulingSystem
    location {
      distance
      latitude
      longitude
      timeZone
    }
  }
}
    `;

export function useBffNearbyFacilitiesByLocationQuery(options: Omit<Urql.UseQueryArgs<BffNearbyFacilitiesByLocationQueryVariables>, 'query'>) {
  return Urql.useQuery<BffNearbyFacilitiesByLocationQuery, BffNearbyFacilitiesByLocationQueryVariables>({ query: BffNearbyFacilitiesByLocationDocument, ...options });
};
export const BffNearbyFacilitiesByZipcodeDocument = gql`
    query bffNearbyFacilitiesByZipcode($brand: BffBrandType!, $zipCode: String!, $radiusMiles: Int) {
  facilitiesByZipcode(brand: $brand, zipCode: $zipCode, radiusMiles: $radiusMiles) {
    code
    name
    phoneNumber
    address {
      address1
      address2
      city
      stateCode
      zipCode
    }
    scheduleAppointmentURL
    schedulingSystem
    location {
      distance
      latitude
      longitude
      timeZone
    }
  }
}
    `;

export function useBffNearbyFacilitiesByZipcodeQuery(options: Omit<Urql.UseQueryArgs<BffNearbyFacilitiesByZipcodeQueryVariables>, 'query'>) {
  return Urql.useQuery<BffNearbyFacilitiesByZipcodeQuery, BffNearbyFacilitiesByZipcodeQueryVariables>({ query: BffNearbyFacilitiesByZipcodeDocument, ...options });
};